import Material from '../../../../types/api/material'
import { EndpointQueryParameters, StrapiCreate } from '../../../../types/strapi/strapi'
import stocksFromExcel from '../../stocksFromExcel.json'
import { useCreateMaterialMutation } from '../../../../store/api/materials-api'
import { useGetMaterialTypesQuery } from '../../../../store/api/material-types-api'
import { FC, useState } from 'react'
import { Button, Tooltip, notification } from 'antd'
import Stock from '../../../../types/api/stock'
import { useCreateStockMutation } from '../../../../store/api/stocks-api'

const getTypesParams: EndpointQueryParameters = {
    fields: ['name', 'documentId'],
    pagination: {
        pageSize: 100,
        page: 1,
    },
}

interface ImportAllMaterialsProps {}

const ImportAllMaterials: FC<ImportAllMaterialsProps> = () => {
    const [createMaterial] = useCreateMaterialMutation()
    const [createStock] = useCreateStockMutation()
    const { data } = useGetMaterialTypesQuery(getTypesParams)
    const allMaterialTypes = data?.data || []

    const [loading, setLoading] = useState(false)

    const createOneMaterial = async (width: number, materialTypeId: string) => {
        const body: StrapiCreate<Material> = {
            data: {
                width,
                material_type: { set: [materialTypeId] },
            },
        }

        try {
            const res = await createMaterial(body)
            if (res.data) {
                console.log('Материал создан:', res.data.data)
                return res.data.data.documentId
            }
        } catch (err) {
            console.error('Ошибка при создании материала:', err)
        }
    }

    const createOneStock = async (amount: number, locked: boolean, materialId: string) => {
        const body: StrapiCreate<Stock> = {
            data: {
                material: { set: [materialId] },
                amount,
                locked,
            },
        }

        try {
            const res = await createStock(body)
            if (res.data) {
                console.log('Остаток создан:', res.data.data)
                return res.data.data.documentId
            }
        } catch (err) {
            console.error('Ошибка при создании остатка:', err)
        }
    }

    const importAllMaterials = async () => {
        setLoading(true)
        try {
            let createdMaterials = 0
            for (const stock of stocksFromExcel) {
                const foundType = allMaterialTypes.find(
                    (t: any) => t.name.trim().toLowerCase() === stock.material.trim().toLowerCase()
                )

                if (!foundType) {
                    console.warn('⚠️ Тип не найден для:', stock.material)
                    continue
                }

                for (const d of stock.data) {
                    const documentId = await createOneMaterial(d.width, foundType.documentId)
                    if (documentId) {
                        await createOneStock(d.length, false, documentId)
                        createdMaterials++
                    }
                }
            }

            notification.success({
                message: 'Импорт завершён',
                description: `Создано материалов: ${createdMaterials}`,
                placement: 'bottomRight',
            })
        } catch (err) {
            notification.error({
                message: 'Ошибка при импорте',
                description: 'Проверьте консоль для подробностей',
                placement: 'bottomRight',
            })
            console.error(err)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Tooltip title="Импортирует все материалы и остатки из Excel в Strapi">
            <Button onClick={importAllMaterials} loading={loading}>
                Импортировать материалы
            </Button>
        </Tooltip>
    )
}

export default ImportAllMaterials
